import Logger from './Log'

const Log = Logger.for('LazyLoad')

/**
 * Monitor viewability ad eventual ad div and wait to render the ad
 * until it is in or nearly in view.
 * Important to pass in the height of the creative since by default
 * the target div will be empty, and wont properly track where the ad
 * would have been on screen. We use the margin value to treat the empty
 * div as the same size as the creative
 */
export default class LazyLoad {
  constructor (target, height, onReady) {
    this._onReadyFired = false
    this._cb = onReady

    this._register(target, height)
  }

  _register (target, height) {
    const margin = (height / 2) + 100
    Log.debug('IO observer with margin of ' + margin)

    /* global IntersectionObserver */
    if ('IntersectionObserver' in window) {
      this._observer = new IntersectionObserver(es => {
        let ev = null
        for (const e of es) {
          if (e.target !== target) continue
          ev = e
        }

        if (!ev) {
          Log.warn('Couldnt find target node in IO event list, firing as a safety precaution')
        }

        if (this._onReadyFired === true) {
          return Log.debug('Got duplicate onready somehow, ignoring')
        } else if (ev.isIntersecting === false) {
          return
        }

        this._onReadyFired = true
        this._observer.disconnect()
        this._observer = false

        target.style.width = this._styleWidth
        target.style.height = this._styleHeight

        this._cb()
      }, { rootMargin: margin + 'px', threshold: 0.01 })

      this._observer.observe(target)
    } else {
      this._observer = false
      this._onReadyFired = true
    }
  }

  onReadyFired () {
    return this._onReadyFired
  }

  stop () {
    if (this._observer) {
      this._observer.disconnect()
    }
  }
}
